var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9403 11.05L12.7503 20.24C11.6244 21.3659 10.0975 21.9984 8.50529 21.9984C6.91311 21.9984 5.38613 21.3659 4.26029 20.24C3.13445 19.1142 2.50195 17.5872 2.50195 15.995C2.50195 14.4029 3.13445 12.8759 4.26029 11.75L12.8303 3.18003C13.5809 2.42815 14.5994 2.00521 15.6618 2.00427C16.7241 2.00334 17.7434 2.42447 18.4953 3.17503C19.2472 3.9256 19.6701 4.9441 19.671 6.0065C19.672 7.06889 19.2509 8.08815 18.5003 8.84003L9.91029 17.41C9.53501 17.7853 9.02602 17.9961 8.49529 17.9961C7.96456 17.9961 7.45557 17.7853 7.08029 17.41C6.70501 17.0348 6.49418 16.5258 6.49418 15.995C6.49418 15.4643 6.70501 14.9553 7.08029 14.58L15.5703 6.10003",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.83abe85347f8878babb1d59938117923.svg";
export { ForwardRef as ReactComponent };